import { render, staticRenderFns } from "./ThirdBanner.vue?vue&type=template&id=d390ca40&scoped=true"
import script from "./ThirdBanner.vue?vue&type=script&lang=js"
export * from "./ThirdBanner.vue?vue&type=script&lang=js"
import style0 from "./ThirdBanner.vue?vue&type=style&index=0&id=d390ca40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d390ca40",
  null
  
)

export default component.exports